import { Link } from "react-router-dom";
import React, { useState } from "react";
import LayoutProvider from "../../../providers/LayoutProvider";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import "./Import.scss";
import { toast, ToastContainer } from "react-toastify";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { exportFlight, importFlight } from "../../../components/Axios/Axios";
import useFileDownload from "../../../hooks/useFileDownload";
import HP from "../../../host";
function Import() {

  const [importFile, setImportFile] = React.useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");

  const downloadFile = useFileDownload()
  //Generate Report Function
  const handleFlightExport = async (event:any) => {
    event.preventDefault();
      try {
        const data = await exportFlight();
        const url= `${HP.request}://${HP.host}/${data}`

        if (url) {
          downloadFile(url, "flight_data.xlsx");
        }
      }
      catch (error) {
        console.error("Error adding flight", error);
      }
    }


  const handleFileImport = () => {
    setImportFile(!importFile);
  };

  const handleFileChange = (event: { target: any; }) => {
    const fileInput = event.target;
    const file = fileInput.files[0];
    
    if (file) {
      setSelectedFileName(file.name);
      // Call importFlight function here
      importFlight(file)
        .then(res => {
          console.log("File imported successfully", res);
          showToastMessage(res.msg)
        })
        .catch((error: any) => {
          console.error("Error importing file", error);
          showFailedToastMessage()
        });
    } else {
      setSelectedFileName("");
    }
   
  };
  
 

  // const handleFlightExport = async (event:any) => {
  //   event.preventDefault();
  //     try {
       
  //       const res = await exportFlight();
  //       console.log("successfull", res);
  //     }
  //     catch (error) {
  //       console.error("Error adding flight", error);
  //     }
  // }

  const showToastMessage = (res:any) => {
    toast(
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ padding: "2px", marginRight: "8px" }}>
          <CheckCircleOutlineIcon />
        </div>
        <span>{res}</span>
      </div>,
      {
        position: "top-center",
        autoClose: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        hideProgressBar: true,
        style: {
          textAlign: "center",
          color: "green",
          background: "#edf7ed",
          borderRadius: "8px",
          padding: "10px",
          fontWeight: "bold",
          borderBottom: "5px solid green",
        },
        
      }
    );
    setSelectedFileName("");
    //CheckCircleOutlineIcon
  };
  const showFailedToastMessage = () => {
    toast(
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ padding: "2px", marginRight: "8px" }}>
          <ErrorOutlineIcon />
        </div>
        <span>Failed</span>
      </div>,
      {
        position: "top-center",
        autoClose: 2000,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        hideProgressBar: true,
        style: {
          textAlign: "center",
          marginRight: "25%",
          color: "#CC0000",
          background: "#fdeded",
          borderRadius: "8px",
          padding: "10px",
          fontWeight: "bold",
          borderBottom: "5px solid #CC0000",
        },
      }
    );
  };
  return (
    <LayoutProvider>
      <section style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between" }}>
        <h4 className="dashboard_heading">Import / Export</h4>
        <h6 className="dashboard_subheading">Dashboard {">"} Import & Export</h6>
      </section>
      <section className="sec_box">
        <div className="row" style={{ alignItems: 'center' }}>
          <div className="col"><h4 className="heading-3" style={{ margin: 0 }}>Import Data</h4></div>
          <div className="col" style={{ textAlign: 'right' }}><button className="btn_def" onClick={handleFileImport}>+ Import File</button></div>
        </div>
        {importFile &&
          <div className="attach_file">
            {/* Image Upload */}
            <div
              style={{
                border: "none !important",
                padding: 0,
                paddingLeft: "3px",
                paddingRight: "3px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                accept=".xlsx"
                id="importFile"
                name="importFile"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />

              {selectedFileName ? (
                <>
                  <label
                    htmlFor="importFile"
                    style={{
                      cursor: "pointer",
                      padding: 0,
                      margin: 0,
                      color: "#00AF80",
                      marginRight: "4px",
                    }}
                  >
                    <CloudUploadIcon style={{ fontSize: "40px" }} />
                  </label>

                  <span style={{ fontSize: "10px" }}>
                    {selectedFileName}
                  </span>
                </>
              ) : (
                <label
                  htmlFor="importFile"
                  style={{
                    cursor: "pointer",
                    padding: 0,
                    margin: 0,
                    color: "#00AF80",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CloudUploadIcon style={{ fontSize: "40px" }} />
                  <span className="heading4" style={{ marginLeft: "4px" }}>
                    Upload File ( CSV/XL)
                  </span>
                </label>
              )}
            </div>

            {/* Image Upload end*/}
          </div>}
      </section>
      <section className="sec_box">
        <h4 className="heading-3">Export Log Data</h4>
        <form className="export_form">
          <label>Select Source</label>
          <select>
            <option value={0}>Select Source</option>
            <option value={'flights'}>Flights Data</option>
            {/* <option value={'airports'}>Airport Data</option> */}
          </select>
          <div className="radio_group">
            {/* <div><input type="radio" value={'pdf'} checked /> PDF</div>
            <div><input type="radio" value={'csv'} /> CSV</div> */}
          </div>
          <button className="btn_def_orange" onClick={handleFlightExport}> Export File</button>
        </form>
      </section>
      <ToastContainer/>
    </LayoutProvider>
  );
}

export default Import;
